import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ValidationFormFieldService {
  private readonly gotoSource = new Subject<any>();

  gotoHandler = this.gotoSource.asObservable();

  goFirst(): void {
    this.gotoSource.next(null);
  }

  gotId(fieldId: string): void {
    this.gotoSource.next(fieldId);
  }
}
